import { helperFunctions } from 'utils/helperFunctions';
import { constants } from '../../../../../constants/Constants';
import { formatApiResponseTimeWithSeconds } from 'components/ApplicationPerformanceOverview/helper';

const { getValueAbbreviationParser, formatTimeWithSeconds } = helperFunctions();

import {
  formatValueWithMiddlewares,
  checkForNA,
  createKpiTileItem,
  appendPercentage,
  removeTrailingZero,
} from '../../../../../v2/utils/helper';

// Helper function to get the correct incident count field based on product
const getIncidentCountField = (incidentData, productId) => {
  return productId === constants.products.MesLite ||
    productId === constants.products.DTC ||
    productId === constants.products.PepsiTastyRewards
    ? incidentData?.incidentCount
    : incidentData?.openIncident;
};

// Helper function to get the correct incident count delta field based on product
const getIncidentCountDeltaField = (incidentData, productId) => {
  return productId === constants.products.MesLite ||
    productId === constants.products.DTC ||
    productId === constants.products.PepsiTastyRewards
    ? incidentData?.incidentCountDelta
    : incidentData?.openIncidentDelta;
};

export const incidentMonitoringScorecrad = (overviewData, ytdCheckbox) => {
  const incidentScoreCardData =
    overviewData?.applicationPeformanceMetricsInOverviewData
      ?.incidentMonitoringOverviewData;
  const appPerfScorecardData = overviewData?.nrmAppPerfScoreCardData;
  const productId = overviewData?.selectedProduct?.productId;
  const period = ytdCheckbox ? 'vs last year' : 'vs last month';
  return {
    metrics: [
      createKpiTileItem(
        'Avg API Response Time',
        formatApiResponseTimeWithSeconds(
          appPerfScorecardData?.avgApiAppResponseTime
        ),
        Number(appPerfScorecardData?.avgApiAppResponseTimeDelta) !== 0
          ? {
              isPositiveValue:
                appPerfScorecardData?.avgApiAppResponseTimeDelta >= 0,
              text: formatValueWithMiddlewares(
                appPerfScorecardData?.avgApiAppResponseTimeDelta,
                [checkForNA, removeTrailingZero, appendPercentage]
              )?.toString(),
              sideLabel: period,
              arrowReversed: false,
            }
          : null
      ),

      createKpiTileItem(
        'Total Number of Errors',
        getValueAbbreviationParser(appPerfScorecardData?.totalNoOfErrors),
        Number(appPerfScorecardData?.totalNoOfErrorsDelta) !== 0
          ? {
              isPositiveValue: appPerfScorecardData?.totalNoOfErrorsDelta >= 0,
              text: formatValueWithMiddlewares(
                appPerfScorecardData?.totalNoOfErrorsDelta,
                [checkForNA, removeTrailingZero, appendPercentage]
              )?.toString(),
              sideLabel: period,
              arrowReversed: false,
            }
          : null
      ),
      createKpiTileItem(
        'Incident Count',
        getValueAbbreviationParser(
          getIncidentCountField(incidentScoreCardData, productId)
        ),
        Number(getIncidentCountDeltaField(incidentScoreCardData, productId)) !==
          0
          ? {
              isPositiveValue:
                getIncidentCountDeltaField(incidentScoreCardData, productId) <
                0,
              text: formatValueWithMiddlewares(
                getIncidentCountDeltaField(incidentScoreCardData, productId),
                [checkForNA, removeTrailingZero, appendPercentage]
              )?.toString(),
              sideLabel: period,
              arrowReversed: true,
            }
          : null
      ),

      createKpiTileItem(
        'Mean Time to Respond',
        formatTimeWithSeconds(incidentScoreCardData?.responseTime),
        Number(incidentScoreCardData?.responseTimeDelta) !== 0
          ? {
              isPositiveValue: incidentScoreCardData?.responseTimeDelta < 0,
              text: formatValueWithMiddlewares(
                incidentScoreCardData?.responseTimeDelta,
                [checkForNA, removeTrailingZero, appendPercentage]
              )?.toString(),
              sideLabel: period,
              arrowReversed: true,
            }
          : null
      ),

      createKpiTileItem(
        'Mean Time to Resolve',
        formatTimeWithSeconds(incidentScoreCardData?.resolutionTime),
        Number(incidentScoreCardData?.resolutionTimeDelta) !== 0
          ? {
              isPositiveValue: incidentScoreCardData?.resolutionTimeDelta < 0,
              text: formatValueWithMiddlewares(
                incidentScoreCardData?.resolutionTimeDelta,
                [checkForNA, removeTrailingZero, appendPercentage]
              )?.toString(),
              sideLabel: period,
              arrowReversed: true,
            }
          : null
      ),
    ],
  };
};
